// extracted by mini-css-extract-plugin
export default {"root":"buyer-item_root__bhgJg","name":"buyer-item_name__e3hNo","offersCount":"buyer-item_offersCount__Tcaur"};